import React from 'react';
import {Application} from "../../../../../Shared/Enums/Enums";
import BorderedDisplay from "../../../../../Shared/UiKit/BorderedDisplay";
import GeneralOverview from "./GeneralOverview";

const APP_NAME = Application.POINT_VISION;

function PointVisionOverview() {
    return <BorderedDisplay text={"Point Vision"}>
        <GeneralOverview appName={APP_NAME}/>
    </BorderedDisplay>
}

export default PointVisionOverview;